import { useEffect } from 'react';
import { useAppContext } from 'src/context/store/app-provider';
import { type Experiment } from 'src/types/experiment';

export const useOnExperimentsReady = (
  fn: (experiments: Experiment[]) => void
) => {
  const { loading, experiments } = useAppContext();

  useEffect(() => {
    if (!loading) {
      fn(experiments);
    }
  }, [experiments, loading, fn]);
};
